import type { StoreGetStoreResponse } from '@/types/redemption'
import { useRuntimeConfig } from '#imports'
import { createApiUtils } from './utils'

const baseUrl = '/redemption/api/store'

export type StoreSearchParams = {
  partnerName: string
  partnerBrand?: string
  partnerRegion?: string
}
export type StoreSearchResponse = {
  storeId: string
  storeCode: string
  storeName: string
  brand: string
  partnerId: string
  algoliaIndex: string
  catalog: string[]
  catalogFilter: {
    product: string
    'product-variant': string
  }
  frameFilter?: string
  lensFilter?: string
  isCorpPerkStore?: boolean
  discountPercentage?: number
  orderMinimum?: number
  couponCode?: string
  currency?: string
}

type UserClientStoreResponses = {
  getOne: StoreGetStoreResponse
  getAll: StoreGetStoreResponse[]
  switchStore: {
    token: string
    storeId: string
    storeCode: string
    storeName: string
    partnerId: string
  }
  search: StoreSearchResponse
}

export const useClientStoreRepository = () => {
  const config = useRuntimeConfig()
  const { execute, getError } = createApiUtils<UserClientStoreResponses>()

  const getOne = (storeId: string) =>
    ({
      url: `${baseUrl}/${storeId}`,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const getAll = () =>
    ({
      url: baseUrl,
      options: {
        method: 'GET',
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const switchStore = (storeId: string) =>
    ({
      url: `${baseUrl}/${storeId}/switch`,
      options: {
        method: 'POST',
        body: {},
        headers: {
          'x-zenni-store-id': config.public.amStoreId as string,
        },
      },
    }) as const

  const search = (query: StoreSearchParams) =>
    ({
      url: `${baseUrl}/search`,
      options: {
        method: 'GET',
        query,
      },
    }) as const

  return {
    getOne,
    getAll,
    switchStore,
    search,
    execute,
    getError,
  }
}
